<div class="cost-plan-form">
    <form [formGroup]="planForm">
        <div class="email-field flex flex-col">
            <label for="email" class="form-label">Your Email Address<span class="require-icon">*</span></label>
            <div class="flex flex-col">
                <input id="email" formControlName="email" pInputText type="text" pSize="large" placeholder="example@email.com" />
                <label *ngIf="planForm.touched" class="email-error" for="email">Please fill in your email address so that we can provide you more details about your cost plan.</label>
            </div>
            <input formControlName="employeeAmounts" type="hidden" name="employeeAmounts" value="" />
        </div>
    </form>
    <div class="plan-title">Build a Team</div>
    <ng-container *ngFor="let item of currentPlan; let i = index; trackBy: trackByRoleName">
        <cost-plan-form-item [role]="item" [employeeLocations]="employeeLocations" [employeeLevels]="employeeLevels" [employeeTypes]="employeeTypes" (formChange)="formChange($event)"></cost-plan-form-item>
    </ng-container>
</div>
<div class="cost-plan-footer flex items-center justify-between md:gap-[16px] xl:gap-[24px]">
    <div class="flex flex-row shrink-0">
        <div class="flex items-center justify-end shrink-0 currency-selector-wrapper">
            <img *ngIf="selectedCurrency === 'USD'" class="flag-icon" src="../../../assets/images/cost-plan/USD-flag.svg" />
            <img *ngIf="selectedCurrency === 'AUD'" class="flag-icon" src="../../../assets/images/cost-plan/Australia.svg" />
            <img *ngIf="selectedCurrency === 'CNY'" class="flag-icon" src="../../../assets/images/cost-plan/China.svg" />
            <div class="currency-selector">
                <p-select class="exchange-rate-selector" [(ngModel)]="selectedCurrency" [options]="['USD', 'AUD', 'CNY']" (onChange)="onExchangeRateClick($event)"></p-select>
                <div class="exchange-rate-label"><a href="https://g.co/kgs/NzvoZf1" target="_blank">Exchange rate</a></div>
            </div>
        </div>
        <div class="customize-divider md:ml-[16px] xl:ml-[48px]"></div>
    </div>
    <div class="flex flex-col md:flex-row justify-between items-center gap-x-[12px] xl:pl-[24px] w-full">
        <div class="cost-section amount-wrapper justify-between">
            <div class="cost-amount-wrapper">
                <div class="cost-title flex">Monthly Cost<span class="seperator">:&nbsp;</span></div>
                <div class="cost-price">
                    <span [pTooltip]="monthlyCostAmountTooltip" appendTo="body" tooltipStyleClass="amount-tooltip">{{ monthlyCostAmount }}</span>
                </div>
            </div>
            <div (click)="onMoreDetailsClick()" class="more-detail-section flex items-center">
                <div class="title">More details</div>
                <img [hidden]="!isShowMoreCostPlanDetail" class="flag-icon arrow-icon" src="../../../assets/images/cost-plan/arrow-down.svg" />
                <img [hidden]="isShowMoreCostPlanDetail" class="flag-icon arrow-icon" src="../../../assets/images/cost-plan/arrow-up.svg" />
            </div>
        </div>
        <div class="cost-section amount-wrapper cost-section-desktop">
            <div class="cost-title">Annual Cost</div>
            <div class="cost-price">
                <span [pTooltip]="annuallyCostAmountTooltip" appendTo="body" tooltipStyleClass="amount-tooltip">{{ annuallyCostAmount }}</span>
            </div>
        </div>
        <div class="cost-section amount-wrapper cost-section-desktop">
            <div class="cost-title">Avg. hourly cost per person</div>
            <div class="cost-price">
                <span [pTooltip]="hourlyCostPerPersonAmountTooltip" appendTo="body" tooltipStyleClass="amount-tooltip">{{ hourlyCostPerPersonAmount }}</span>
            </div>
        </div>
        @if (isShowMoreCostPlanDetail) {
            <div class="cost-section cost-section-mobile">
                <div class="cost-title">Annual Cost:&nbsp;</div>
                <div class="cost-price">
                    {{ annuallyCostAmount }}
                </div>
            </div>
            <div class="cost-section cost-section-mobile">
                <div class="cost-title">Avg. hourly cost per person:&nbsp;</div>
                <div class="cost-price">
                    {{ hourlyCostPerPersonAmount }}
                </div>
            </div>
        }
    </div>
    <button class="btn btn-primary request-quote shrink-0" [disabled]="employeeAmounts === 0" (click)="requestQuote()">Request Quote</button>
</div>
